/*
  nh-geschenk.js - Geschenk ab Warenkorbwert (data-modus="betrag", z. B. 140 EUR)
  oder ab einer Anzahl passender Artikel (z. B. 2 Hoodies).
  Betrags-Modus: Summe final_line_price aller Zeilen ohne Geschenk (nach
  Rabatten), in Cent; data-anzahl traegt dann die Schwelle in Cent und
  [anzahl] in den Texten wird als Geldbetrag ausgegeben.
  Gehoert zu snippets/nh-geschenk.liquid, eingebunden in layout/theme.liquid.

  ZAEHLEN: /cart.js liefert keine Tags. Deshalb holt das Skript pro Produkt
  einmal /products/<handle>.js (enthaelt tags und type) und merkt sich das
  Ergebnis. Schlaegt das fehl, ist die Anzahl UNBEKANNT - dann wird nichts
  entfernt (Netz 1 schweigt), Netz 2 schuetzt weiter das Geld, weil der
  Shopify-Rabatt selbst die Hoodie-Anzahl prueft.

  ZWEI SICHERHEITSNETZE, unabhaengig voneinander:
    1) Anzahl - liegen OHNE Geschenk weniger passende Artikel im Korb als
       verlangt, wird die Geschenkposition entfernt.
    2) Preis - steht die Geschenkposition nicht auf 0, wird sie entfernt.
       Das faengt fehlenden, abgelaufenen, kollidierenden oder falsch
       eingestellten Rabatt ab, ohne dass das Theme davon wissen muss.
       Netz 2 ist der eigentliche Geldschutz.

  KEIN ajaxProduct:added FEUERN. theme.js:4411-4413 haengt daran und ruft
  this.open() - auf der Warenkorbseite spraenge dadurch das Schubfach ueber
  die Seite. cart:build (theme.js:1732) baut die Positionsliste in beiden
  Oberflaechen neu, cart:updated bedient free-shipping-bar.js:48 ohne
  zusaetzliche Netzwerkrunde. Zusammen dieselbe Wirkung ohne Nebenwirkung.
  Bitte nicht "zurueckreparieren".

  KEINE TEXTE HIER. Alle Texte kommen per data-Attribut aus den
  Theme-Einstellungen. free-shipping-bar.js:31/33 macht es andersherum und
  wuerde jede Editor-Einstellung uebergehen.

  Bis 18.10.2026 zaehlte hier ein Warenkorbwert (Schwelle in EUR/CHF).
  Die Betrags-Logik ist komplett entfernt.
*/
(function () {
  if (window.__nhGeschenkInit) return;
  window.__nhGeschenkInit = true;

  var PROP = '_nh_geschenk';
  var busy = false;
  var nachholen = false;
  var lastGift = null;
  var korrekturen = 0;
  var notbremse = false;

  setInterval(function () { korrekturen = 0; }, 10000);

  function route(name, fallback) {
    return (window.theme && window.theme.routes && window.theme.routes[name]) || fallback;
  }

  var produktCache = {};

  function wurzel() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  // true/false, ob das Produkt zaehlt; null, wenn es nicht feststellbar war
  function zaehltProdukt(item, tag) {
    var id = item.product_id;
    if (produktCache.hasOwnProperty(id)) return Promise.resolve(produktCache[id]);
    return fetch(wurzel() + 'products/' + item.handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('produkt ' + r.status);
        return r.json();
      })
      .then(function (p) {
        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase().trim(); });
        var ok = p.type !== 'giftbox_ghost_product' && tags.indexOf(tag) !== -1;
        produktCache[id] = ok;
        return ok;
      })
      .catch(function () { return null; });
  }

  function module_() {
    return document.querySelectorAll('[data-nh-geschenk]');
  }

  function giftLines(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (item) {
      return item.properties && item.properties[PROP];
    });
  }

  // Anzahl passender Artikel OHNE das Geschenk, Mengen addiert.
  // Liefert null, wenn auch nur ein Produkt nicht feststellbar war.
  // Im Betrags-Modus: Zahl als Geldbetrag (Cent -> Waehrung des Warenkorbs)
  function anzahlText(el, n) {
    if (el.getAttribute('data-modus') !== 'betrag') return String(n);
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur }).format(n / 100);
    } catch (e) { return (n / 100).toFixed(2); }
  }

  function zaehle(cart) {
    var el = module_()[0];
    if (!el || !cart || !cart.items) return Promise.resolve(0);
    if (el.getAttribute('data-modus') === 'betrag') {
      // Warenkorbwert ohne Geschenk, nach Rabatten (Cent)
      return Promise.resolve(cart.items.filter(function (item) {
        return !(item.properties && item.properties[PROP]);
      }).reduce(function (a, item) { return a + (item.final_line_price || 0); }, 0));
    }
    var tag = (el.getAttribute('data-tag') || 'hood').toLowerCase().trim();
    var kandidaten = cart.items.filter(function (item) {
      return !(item.properties && item.properties[PROP]);
    });
    return Promise.all(kandidaten.map(function (item) {
      return zaehltProdukt(item, tag).then(function (ok) {
        if (ok === null) return null;
        return ok ? item.quantity : 0;
      });
    })).then(function (werte) {
      if (werte.indexOf(null) !== -1) return null;
      return werte.reduce(function (a, b) { return a + b; }, 0);
    });
  }

  function anzahl() {
    var el = module_()[0];
    if (!el) return 0;
    return parseInt(el.getAttribute('data-anzahl'), 10) || 0;
  }

  function aendere(key, menge) {
    var body = new FormData();
    body.append('id', key);
    body.append('quantity', String(menge));
    return fetch(route('cartChange', '/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: body
    }).then(function (r) { return r.json(); });
  }

  // Mehrere Geschenkzeilen nacheinander, nie parallel - parallele
  // Warenkorb-Mutationen ueberschreiben sich in Shopify gegenseitig.
  function entferneAlle(lines) {
    return lines.reduce(function (kette, line) {
      return kette.then(function () { return aendere(line.key, 0); });
    }, Promise.resolve());
  }

  function zeigeHinweis(el, text) {
    var p = el.querySelector('[data-nh-geschenk-hinweis]');
    if (!p) return;
    if (!text) {
      p.hidden = true;
      p.textContent = '';
      return;
    }
    p.textContent = text;
    p.hidden = false;
    setTimeout(function () { p.hidden = true; }, 8000);
  }

  function hinweisUeberall(attribut) {
    Array.prototype.forEach.call(module_(), function (el) {
      var vorlage = el.getAttribute(attribut) || '';
      vorlage = vorlage.replace('[anzahl]', anzahlText(el, parseInt(el.getAttribute('data-anzahl'), 10) || 0));
      zeigeHinweis(el, vorlage);
    });
  }

  // gezaehlt: Anzahl aus zaehle(); null = unbekannt -> Zustand bleibt, wie er ist
  function rendere(cart, gezaehlt) {
    var lines = giftLines(cart);
    var gift = lines[0] || null;

    Array.prototype.forEach.call(module_(), function (el) {
      var grenze = parseInt(el.getAttribute('data-anzahl'), 10);
      if (!grenze || isNaN(grenze)) return;
      if (gezaehlt === null && !gift) return;

      var reached = gezaehlt >= grenze;
      var remaining = Math.max(grenze - (gezaehlt || 0), 0);
      var zustand;
      if (gift) zustand = gift.final_line_price === 0 ? 'imkorb' : 'fehler';
      else zustand = reached ? 'bereit' : 'unter';

      el.setAttribute('data-state', zustand);

      var text = el.querySelector('[data-nh-geschenk-text]');
      if (!text) return;

      if (zustand === 'imkorb') {
        text.textContent = el.getAttribute('data-text-liegt') || '';
      } else if (zustand === 'fehler') {
        text.textContent = el.getAttribute('data-text-fehler') || '';
      } else if (zustand === 'bereit') {
        text.textContent = el.getAttribute('data-text-bereit') || '';
      } else {
        var einzeln = el.getAttribute('data-text-offen-1') || '';
        var vorlage = (remaining === 1 && einzeln) ? einzeln : (el.getAttribute('data-text-offen') || '');
        text.textContent = vorlage.replace('[anzahl]', anzahlText(el, remaining));
      }
    });

    lastGift = gift;
    markiereZeile(gift);
  }

  // Mengenwaehler der Geschenkposition sperren. Ueber JS, damit
  // snippets/cart-item.liquid (Motion-Datei) unangetastet bleibt.
  function markiereZeile(gift) {
    Array.prototype.forEach.call(document.querySelectorAll('.nh-geschenk-position'), function (el) {
      el.classList.remove('nh-geschenk-position');
    });
    if (!gift) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-key]'), function (el) {
      var key = el.getAttribute('data-key') || '';
      if (key === gift.key || key.indexOf(gift.key) === 0) {
        el.classList.add('nh-geschenk-position');
        setzeGratisWort(el);
      }
    });
  }

  // Motions cartMarkup() ersetzt [data-products] komplett, der Preisknoten ist
  // danach neu. Deshalb laeuft das bei jedem Durchgang mit und merkt sich pro
  // Knoten, dass es schon gelaufen ist.
  function setzeGratisWort(zeile) {
    var modul = document.querySelector('[data-nh-geschenk]');
    var wort = modul ? (modul.getAttribute('data-text-gratis') || '') : '';
    if (!wort) return;
    var preis = zeile.querySelector('.cart__price.cart__discount');
    if (!preis || preis.hasAttribute('data-nh-gratis')) return;
    preis.setAttribute('data-nh-gratis', '1');
    preis.textContent = wort;
  }

  function meldeWarenkorb(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  // Die beiden Sicherheitsnetze
  function pruefe(cart) {
    return zaehle(cart).then(function (gezaehlt) { return pruefeMit(cart, gezaehlt); });
  }

  function pruefeMit(cart, gezaehlt) {
    var lines = giftLines(cart);

    if (!lines.length || notbremse) {
      rendere(cart, gezaehlt);
      return Promise.resolve();
    }

    var grenze = anzahl();
    // Anzahl unbekannt -> Netz 1 schweigt, Netz 2 (Preis) bleibt aktiv
    var unterSchwelle = gezaehlt !== null && grenze > 0 && gezaehlt < grenze;
    var nichtGratis = lines.some(function (l) { return l.final_line_price > 0; });
    var zuViele = lines.length > 1 || lines[0].quantity > 1;

    // Menge erst zuruecksetzen - danach kann der Preis wieder stimmen
    if (!unterSchwelle && zuViele) {
      return mitRiegel(function () {
        var kette = entferneAlle(lines.slice(1));
        return kette
          .then(function () {
            if (lines[0].quantity > 1) return aendere(lines[0].key, 1);
          })
          .then(hole);
      });
    }

    if (unterSchwelle || nichtGratis) {
      return mitRiegel(function () {
        return entferneAlle(lines).then(function () {
          return hole().then(function (neu) {
            hinweisUeberall(unterSchwelle ? 'data-text-entfernt' : 'data-text-fehler');
            return neu;
          });
        });
      });
    }

    rendere(cart, gezaehlt);
    return Promise.resolve();
  }

  function mitRiegel(aktion) {
    if (busy) { nachholen = true; return Promise.resolve(); }

    korrekturen += 1;
    if (korrekturen > 3) {
      notbremse = true;
      if (window.console) console.warn('[nh-geschenk] Notbremse: zu viele Korrekturen in kurzer Zeit');
      return Promise.resolve();
    }

    busy = true;
    return aktion()
      .then(function (cart) {
        busy = false;
        if (cart) {
          meldeWarenkorb(cart);
          return zaehle(cart).then(function (n) { rendere(cart, n); });
        }
      })
      .then(function () {
        if (nachholen) { nachholen = false; aktualisiere(); }
      })
      .catch(function () {
        busy = false;
        nachholen = false;
      });
  }

  function hole() {
    return fetch(route('cart', '/cart.js') + '?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function aktualisiere() {
    if (busy) { nachholen = true; return Promise.resolve(); }
    return hole().then(pruefe).catch(function () {});
  }

  function lege(knopf) {
    if (busy || notbremse || knopf.hasAttribute('disabled')) return;

    var el = knopf.closest('[data-nh-geschenk]');
    if (!el) return;

    // Gewaehlte Option (bei zwei Geschenkartikeln), darin ggf. die Variante
    var radio = el.querySelector('[data-nh-geschenk-radio]:checked');
    var option = radio ? radio.closest('[data-nh-geschenk-option]') : null;
    var select = option ? option.querySelector('[data-nh-geschenk-select]') : el.querySelector('[data-nh-geschenk-select]');
    var variantId = select ? select.value : (radio ? radio.value : el.getAttribute('data-variant-id'));
    if (!variantId) return;

    busy = true;
    zeigeHinweis(el, '');
    knopf.setAttribute('disabled', 'disabled');
    knopf.classList.add('is-loading');

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    body.append('properties[' + PROP + ']', '1');

    fetch(route('cartAdd', '/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, body: d }; }); })
      .then(function (res) {
        knopf.classList.remove('is-loading');
        knopf.removeAttribute('disabled');
        busy = false;

        if (!res.ok) {
          zeigeHinweis(el, el.getAttribute('data-text-fehler') || '');
          return;
        }
        return hole().then(function (cart) {
          meldeWarenkorb(cart);
          return pruefe(cart);
        });
      })
      .catch(function () {
        knopf.classList.remove('is-loading');
        knopf.removeAttribute('disabled');
        busy = false;
        zeigeHinweis(el, el.getAttribute('data-text-fehler') || '');
      });
  }

  // Farbe im Auswahlfeld gewaehlt -> zugehoerige Option mit anwaehlen
  document.addEventListener('change', function (evt) {
    var sel = evt.target.closest && evt.target.closest('[data-nh-geschenk-option] [data-nh-geschenk-select]');
    if (!sel) return;
    var r = sel.closest('[data-nh-geschenk-option]').querySelector('[data-nh-geschenk-radio]');
    if (r) r.checked = true;
  });

  document.addEventListener('click', function (evt) {
    var knopf = evt.target.closest && evt.target.closest('[data-nh-geschenk-knopf]');
    if (!knopf) return;
    evt.preventDefault();
    lege(knopf);
  });

  document.addEventListener('cart:updated', function (e) {
    if (busy) { nachholen = true; return; }
    if (e && e.detail && e.detail.cart) pruefe(e.detail.cart);
    else aktualisiere();
  });

  // Quick-Add, Cross-Sell und teeinblue liefern keinen Warenkorb im detail.
  document.addEventListener('ajaxProduct:added', function () { aktualisiere(); });
  document.addEventListener('cart:build', function () { aktualisiere(); });

  // Zurueck-Knopf: die Seite kommt aus dem bfcache, das Markup ist veraltet.
  window.addEventListener('pageshow', function (e) { if (e.persisted) aktualisiere(); });

  function starte() {
    aktualisiere();
    // Motion ersetzt beim Neuaufbau den Inhalt von [data-products]; dabei geht
    // die Markierung der Geschenkposition verloren und wird hier neu gesetzt,
    // ohne den Warenkorb erneut zu laden.
    if (!window.MutationObserver) return;
    var timer = null;
    var beobachter = new MutationObserver(function () {
      if (!lastGift) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { markiereZeile(lastGift); }, 60);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-products]'), function (el) {
      beobachter.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starte);
  } else {
    starte();
  }
})();
